import { Platform } from "react-native"
import { IAnyStateTreeNode } from "mobx-state-tree/dist/internal"
import { detach } from "mobx-state-tree"
import { Toast } from "native-base"
import SyncableModel from "../../database/SyncableModel"
import _ from "lodash"

export const withBaseStoreModels = (self) => ({
  actions: {
    set(key: string, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    setArrayBaseModelStore(
      key: string,
      values: Array<any>,
      modelId: string, model: string, modelKey: string,
      defaultStore: (props?: any) => IAnyStateTreeNode
    ) {
      try {
        const modelStores = _.groupBy(
          _.map(self[key], (modelStore, index: number) => ({ modelStore, index })),
          `modelStore.${modelId}`
        )
        this.set(key, values.map((value, index) => {
          let { modelStore, index: modelStoreIndex } = (modelStores[value[modelKey]] || [])[0] || {};
          if (!modelStore) modelStore = defaultStore({[modelId]: value[modelKey]});
          else if (index !== modelStoreIndex) modelStore = detach(modelStore);
          // modelStore.set(modelId, value[modelKey]);
          modelStore.set(model, value);
          return modelStore;
        }))
      } catch (e) {
        console.warn(e);
        this.set(key, []);
      }
    },
    setMapBaseModelStore(
      key: string,
      values: any,
      modelId: string, model: string, modelKey: string,
      defaultStore: (props?: any) => IAnyStateTreeNode
    ) {
      try {
        const modelStores = self[key];
        const newModelStores = {};
        values.forEach((value) => {
          let modelStore = modelStores[value[modelKey]];
          if (!modelStore) modelStore = defaultStore({[modelId]: value[modelKey]});
          modelStore.set(model, value);
          newModelStores[value[modelKey]] = modelStore;
        })
        this.set(key, newModelStores);
      } catch (e) {
        console.warn(e);
        this.set(key, {});
      }
    },
    async getModels(
      Model: typeof SyncableModel,
      queryingModel: string, syncingModel: string, syncedModel: string,
      params: any,
      setArrayModelStore: (models: Array<SyncableModel>) => void,
      sync = true,
      syncModels?: (model: typeof SyncableModel, syncingModel: string) => Promise<void>,
      onFinishSync = undefined
    ) {
      if (!sync) {
        this.set(queryingModel, true);
        const models = await Model.fetch(params).catch((error) => {
          console.warn(error)
          return []
        })
        await setArrayModelStore(models);
        if (models.length)
          this.set(syncedModel, true);
        this.set(queryingModel, false);

        return models;
      }
      else {
        this.set(queryingModel, true);
        if (!self[syncedModel]) {
          const models = await this.getModels(
            Model,
            queryingModel, syncingModel, syncedModel,
            params, setArrayModelStore,
            false
          ).catch(() => []);
          if (models.length && onFinishSync) {
            onFinishSync();
            this.set(syncedModel, true);
          }
          (syncModels || this.syncModels)(Model, syncingModel).then(async (success) => {
            await this.getModels(
              Model,
              queryingModel, syncingModel, syncedModel,
              params, setArrayModelStore,
              false
            ).catch(() => [])
            if (!models.length && onFinishSync) onFinishSync(success);
          }).finally(() => {
            this.set(syncedModel, true);
            this.set(queryingModel, false);
          })
        } else {
          (syncModels || this.syncModels)(Model, syncingModel).then(async (success) => {
            await this.getModels(
              Model,
              queryingModel, syncingModel, syncedModel,
              params, setArrayModelStore,
              false
            ).catch(() => [])
            if (onFinishSync) onFinishSync(success)
          }).finally(() => {
            this.set(syncedModel, true);
            this.set(queryingModel, false);
          })
        }
        return [];
      }
    },
    async syncModels(Model: typeof SyncableModel, syncingModel: string) {
      if (Platform.OS === 'web') return true;

      this.set(syncingModel, true)
      const success = await Model.syncAll(
        {},
        [], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )

      this.set(syncingModel, false)
      return success
    }
  }
})
